import {ILocale} from "./locale.type";

const Locale: ILocale = {
    language: "en",
    locale: "en-IN",
    timezone: "Asia/Kolkata",

    // Backend-safe formats
    dateFormat: "YYYY-MM-DD",
    timeFormat: "HH:MM:SS A",
    dateTimeFormat: "YYYY-MM-DDTHH:mm:ss",

    // UI display formats
    displayDate: "DD-MM-YYYY",
    displayDateLong: "D MMM YYYY",
    displayDateTime: "DD-MM-YYYY, hh:mm:ss A",
    displayTime: "hh:mm:ss A",
    displayTimeShort: "hh:mm A",
    displayDateWithDay: "DD-MM-YYYY ddd",
    displayDateWithMonth: "DD MMMM , YYYY",
    displayDateAndMonth: "DD MMM",

    mobileCountryCode: "+91",

    weatherLocation: {
        city: "Bengaluru",
        countryCode: "IN",
        latitude: 12.9716,
        longitude: 77.5946
    }
};

export default Locale;
